import { render, staticRenderFns } from "./PredictionsGlobal.vue?vue&type=template&id=da35fa6a&"
import script from "./PredictionsGlobal.vue?vue&type=script&lang=js&"
export * from "./PredictionsGlobal.vue?vue&type=script&lang=js&"
import style0 from "./PredictionsGlobal.vue?vue&type=style&index=0&id=da35fa6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports